<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap justify-center align-center>
      <v-flex xs12 sm6>
        <v-card>
          <v-toolbar class="elevation-0" height="45" color="gray">
            <v-toolbar-title>
              <h1 class="subheading">New Word</h1>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  :error-messages="keyNameErrors"
                  v-model="Language.KeyName"
                  label="Key Word"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :error-messages="englishErrors"
                  v-model="Language.English"
                  label="English"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :error-messages="spanishErrors"
                  v-model="Language.Spanish"
                  label="Spanish"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :error-messages="frenchErrors"
                  v-model="Language.French"
                  label="French"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" flat @click="cancel">Cancel</v-btn>
            <v-spacer> </v-spacer>
            <v-btn color="blue darken-1" dark @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import languageService from "../service.js";
const { validationMixin } = require("vuelidate");
const { required, minLength, minValue, sameAs, email } = require("vuelidate/lib/validators");

export default {
  name: "create-language",
  data() {
    return {
      Language: {
        KeyName: null,
        English: null,
        Spanish: null,
        French: null
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    Language: {
      KeyName: {
        required
      },
      English: {
        required
      },
      Spanish: {
        required
      },
      French: {
        required
      }
    }
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    keyNameErrors() {
      const errors = [];
      if (!this.$v.Language.KeyName.$dirty) return errors;
      if (!this.$v.Language.KeyName.required) errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    englishErrors() {
      const errors = [];
      if (!this.$v.Language.English.$dirty) return errors;
      if (!this.$v.Language.English.required) errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    spanishErrors() {
      const errors = [];
      if (!this.$v.Language.Spanish.$dirty) return errors;
      if (!this.$v.Language.Spanish.required) errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    frenchErrors() {
      const errors = [];
      if (!this.$v.Language.French.$dirty) return errors;
      if (!this.$v.Language.French.required) errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    }
  },
  methods: {
    cancel() {
      this.$router.go(-1);
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        if (this.Language.KeyName.substring(0, 3).toLowerCase() === "key") {
          this.$swal({
            title: "System Word!",
            text:
              "Key is system work please try using something otherthen key in start of the word.",
            type: "warning"
          });
        } else {
          this.Language.KeyName = 'key' + this.Language.KeyName.replace(/\s/g, '')
          return languageService
            .create(this.Language)
            .then(result => {
              console.log("this.result", result);
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "success",
                  title: "Language added!"
                });
              this.cancel();
            })
            .catch(err => {
              console.log("err", err);
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "error",
                  title: err.data.data
                });
            });
        }
      }
    }
  }
};
</script>

